"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Saber = void 0;
const tslib_1 = require("tslib");
const anchor_1 = require("@project-serum/anchor");
const solana_contrib_1 = require("@saberhq/solana-contrib");
const lodash_1 = require("lodash");
const tiny_invariant_1 = (0, tslib_1.__importDefault)(require("tiny-invariant"));
const constants_1 = require("../constants");
const eventParser_1 = require("../utils/eventParser");
const farm_1 = require("./wrappers/farm");
const mintProxy_1 = require("./wrappers/mintProxy");
/**
 * Saber SDK.
 */
class Saber {
    constructor(provider, programs) {
        this.provider = provider;
        this.programs = programs;
    }
    /**
     * Creates a new instance of the SDK with the given keypair.
     */
    withSigner(signer) {
        return Saber.load({
            provider: new solana_contrib_1.SolanaProvider(this.provider.connection, this.provider.broadcaster, new solana_contrib_1.SignerWallet(signer), this.provider.opts),
            addresses: (0, lodash_1.mapValues)(this.programs, (v) => v.programId),
        });
    }
    get programList() {
        return Object.values(this.programs);
    }
    get mintProxy() {
        return new mintProxy_1.MintProxyWrapper(this);
    }
    get farm() {
        return new farm_1.FarmWrapper(this);
    }
    parseProgramLogs(logs) {
        const events = [];
        this.programList.forEach((prog) => {
            const parser = new eventParser_1.EventParser(prog.coder, prog.programId);
            parser.parseLogs(logs, (event) => {
                events.push(event);
            });
        });
        return events;
    }
    /**
     * Gets the event parser for the given event.
     * @param program Name of program to parse.
     * @returns Event parser
     */
    getParser(program) {
        const parser = new eventParser_1.EventParser(this.programs[program].coder, this.programs[program].programId);
        return (logs) => {
            const events = [];
            parser.parseLogs(logs, (event) => {
                events.push(event);
            });
            return events;
        };
    }
    /**
     * Constructs a new transaction envelope.
     * @param instructions
     * @param signers
     * @returns
     */
    newTx(instructions, signers) {
        return new solana_contrib_1.TransactionEnvelope(this.provider, instructions, signers);
    }
    /**
     * Loads the SDK.
     * @returns
     */
    static load({ provider, addresses = constants_1.SUNNY_ADDRESSES, }) {
        const anchorProvider = new anchor_1.Provider(provider.connection, provider.wallet, provider.opts);
        const allAddresses = Object.assign(Object.assign({}, constants_1.SUNNY_ADDRESSES), addresses);
        const programs = (0, lodash_1.mapValues)(constants_1.SUNNY_ADDRESSES, (_, programName) => {
            const address = allAddresses[programName];
            const idl = constants_1.SUNNY_IDLS[programName];
            (0, tiny_invariant_1.default)(idl, `Unknown IDL: ${programName}`);
            return new anchor_1.Program(idl, address, anchorProvider);
        });
        return new Saber(provider, programs);
    }
}
exports.Saber = Saber;
//# sourceMappingURL=sdk.js.map